import { createSlice } from '@reduxjs/toolkit';

import { loadSignedAgreementsItem, loadSignedAgreementsList } from './actions';
import { SignedAgreementsState } from './interfaces';

export const signedAgreementsSlice = createSlice({
  name: 'signedAgreements',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as SignedAgreementsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadSignedAgreementsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(
      loadSignedAgreementsItem.fulfilled,
      (state, { payload }) => {
        state.item = payload;
      }
    );
  },
});
